// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CiOutlinedSvg from "@fishx/icons-svg/es/asn/CiOutlined";
import FishxIcon from '../components/FishxIcon';

var CiOutlined = function CiOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: CiOutlinedSvg
  }));
};

CiOutlined.displayName = 'CiOutlined';
export default React.forwardRef(CiOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/CiOutlined.js
// module id = 2218
// module chunks = 0